export default (url: string, e?: any) => {
  if (e) {
    e.preventDefault();
  }
  window.open(url, '_blank');
};
